import { router, useGlobalSearchParams } from "expo-router";
import { useEffect } from "react";
import { ActivityIndicator, View } from "react-native";
import { Page } from "~/components/layout/Page";
import { Subtitle } from "~/components/layout/text";
import { Gap, Items } from "~/constants/layout";
import { useApi } from "~/providers/ApiProvider";
import { useFeedback } from "~/providers/FeedbackProvider";

export default function VerifyEmail() {
    const { id, token }: { id: string; token: string } = useGlobalSearchParams();
    const { client } = useApi();
    const { addToast } = useFeedback();

    // biome-ignore lint/correctness/useExhaustiveDependencies(client): API
    // biome-ignore lint/correctness/useExhaustiveDependencies(addToast): feedback
    useEffect(() => {
        client()
            .get(`/verify-email/${id}/${token}`)
            .then(() => {
                addToast({ content: "Thank you, your email address has been verified." });
            })
            .catch(() => {
                addToast({ content: "Could not verify email address." });
            })
            .finally(() => {
                router.dismissTo("/dashboard");
            });
    }, [id, token]);

    return (
        <Page gradient spacer>
            <View style={[Items.center, Gap.xxl]}>
                <ActivityIndicator size="large" />
                <Subtitle>Verifying email address...</Subtitle>
            </View>
        </Page>
    );
}
